export const PricingCalculationsModuleTranslations: Array<string> = [
    // Pricing settings
    'Admin.Providers.PricingSettings',
    'Admin.Providers.PricingSettings.DocumentPricingProcedureName',
    'Admin.Providers.PricingSettings.CustomerPricingProcedureName',
    'Admin.Providers.PricingSettings.PricingProcedureName',
    'Admin.Providers.PricingSettings.PricingProcedureNameForCatalog',
    'Admin.Providers.PricingSettings.PricingProcedureNameForCatalogInfo',
    'Admin.Providers.PricingSettings.PricingProcedureNameInfo',
    'Admin.Providers.PricingSettings.DocumentPricingProcedureNameInfo',
    'Admin.Providers.PricingSettings.CustomerPricingProcedureNameInfo',
    'Admin.Providers.PricingSettings.PricingDuringConfigurationSection',
    'Admin.Providers.PricingSettings.SortOrder',
    'Admin.Providers.PricingSettings.SortOrderInfo',
    'Admin.Providers.PricingSettings.UseCPSAsPricingEngineForQuoteTotalFields',
    'Admin.Providers.PricingSettings.UseCPSAsPricingEngineForQuoteTotalFieldsHint',
    'Admin.Providers.PricingSettings.UseFormulaForConditionDetermination',
    'Admin.Providers.PricingSettings.UseFormulaForConditionDeterminationHint',
    'Admin.CPSProvider.FormulaTooltip',
    'Admin.Providers.PricingSettings.GeneralSection',
    'Admin.Providers.PricingSettings.ItemSpecificSection',
    'Admin.Providers.PricingSettings.SalesOrg',
    'Admin.Providers.PricingSettings.SalesOrgInfo',
    'Admin.Providers.PricingSettings.EnableConditionDelete',
    'Admin.Providers.PricingSettings.StandalonePricingProcedureName',
    'Admin.Providers.PricingSettings.StandalonePricingProcedureNameInfo',

    // Pricing procedures datatable
    'Admin.Providers.PricingProceduresQuickSearch',
    'Admin.Providers.PricingProcedures.TotalRecords',
    'Admin.Providers.PricingProcedures.Name',
    'SalesArea.Assigments.SalesOrganization',
    'Admin.Providers.PricingProcedures.DistributionChannel',
    'Admin.Providers.PricingProcedures.Division',
    'Admin.Providers.PricingProcedures.DocumentPricingProcedure',
    'Admin.Providers.PricingProcedures.CustomerPricingProcedure',
    'Admin.PricingProcedure.Resync',
    'Admin.PricingProcedure.SuccessfullyResynced',
    'Admin.PricingProcedure.ResyncWarning.Title',
    'Admin.PricingProcedure.ResyncWarning.Message.Part1',
    'Admin.PricingProcedure.ResyncWarning.Message.Part2',
    'Admin.PricingProcedure.ResyncWarning.Message.Part3',
    'Admin.PricingProcedure.ResyncWarning.Message.Part4',

    //Pricing procedure determinations
    'Admin.PricingProcedures.Determinations',
    'Admin.PricingProcedureDeterminations.QuickFilter',
    'Admin.CPSPricingProcedureDeterminations.QuickFilter',
    'Admin.PricingProcedureDeterminations.Total',
    'Admin.AddNewPricingProcedureDetermination',
    'Admin.PricingProcedureDeterminations.Validation.Header.RequiredFields',
    'Admin.PricingProcedureDeterminations.Validation.RequiredFields',
    'Admin.PricingProcedureDeterminations.Validation.Header.Duplicate',
    'Admin.PricingProcedureDeterminations.Validation.Duplicate',

    //Pricing procedures validations
    'Admin.PricingProcedures.Validation.Header.RequiredFields',
    'Admin.PricingProcedures.Validation.RequiredFields',
    'Admin.PricingProcedures.Validation.Header.DuplicatePricingProcedure',
    'Admin.PricingProcedures.Validation.DuplicatePricingProcedure',

    'Admin.Providers.PricingProcedures',
    'Admin.AddNewPricingProcedure',
    'Admin.PricingProcedures.Actions',
    'Admin.Msg.AddProcedure',
    'Admin.Msg.SaveButton',
    'xmlPricingConditionMappings',
    'Admin.PricingProceduresDefinition',
    'API.SetupSPA.PricingConditionsMapping.InvalidCombination',

    'Admin.PricingProcedure.Details',
    'Admin.PricingProcedure.Rename',
    'Admin.PricingProcedure.Save',
    'Admin.PricingProcedure.Cancel',
    'Admin.PricingProcedure.ID',
    'Admin.PricingProcedure.Description',

    'Admin.PricingProceduresPricingConditions',
    'Admin.CpsPricingConditions.Title',
    'Admin.AddNewPricingCondition',
    'Admin.PricingCondition.Manage',
    'Admin.CPSPricingConditions.ManageConditionsDialog.QuickSearch',
    'Admin.PricingCondition.ExpandCollapseAll',
    'Admin.PricingCondition.Details',
    'Admin.PricingCondition.Step',
    'Admin.PricingCondition.Name',
    'Admin.PricingCondition.PricingCondition',
    'Admin.PricingCondition.PricingFrequency',
    'Admin.PricingCondition.PricingFrequencyTooltip',
    'Admin.PricingCondition.RateValue',
    'Admin.PricingCondition.QuoteItem',
    'Admin.PricingCondition.QuoteHeader',
    'Admin.PricingCondition.QuoteHeaderTooltip',
    'Admin.CpsPricingConditions.InvertValue',
    'Admin.CpsPricingConditions.ScaledCondition',
    'Admin.PricingCondition.Details.ScaleBasis',
    'Admin.PricingCondition.Details.ScaleBasis.Empty',
    'Admin.PricingCondition.Details.ScaleBasis.B',
    'Admin.PricingCondition.Details.ScaleBasis.C',
    'Admin.PricingCondition.Details.ScaleBasis.D',
    'Admin.PricingCondition.Details.ScaleBasis.E',
    'Admin.PricingCondition.Details.ScaleBasis.F',
    'Admin.PricingCondition.Details.ScaleBasis.G',
    'Admin.PricingCondition.Details.ScaleBasis.L',
    'Admin.PricingCondition.Details.ScaleBasis.M',
    'Admin.PricingCondition.Details.ScaleBasis.N',
    'Admin.PricingCondition.Details.ScaleBasis.O',
    'Admin.PricingCondition.Details.ScaleBasis.P',
    'Admin.PricingCondition.Details.ScaleBasis.R',
    'Admin.PricingCondition.Details.ScaleBasis.S',
    'Admin.PricingCondition.Details.ScaleType',
    'Admin.PricingCondition.Details.ScaleType.Empty',
    'Admin.PricingCondition.Details.ScaleType.A',
    'Admin.PricingCondition.Details.ScaleType.B',
    'Admin.PricingCondition.Details.ScaleType.C',
    'Admin.PricingCondition.Details.ScaleType.D',
    'Admin.PricingCondition.Details.ScaleOrder',
    'Admin.PricingCondition.Details.ScaleOrder.Empty',
    'Admin.PricingCondition.Details.ScaleOrder.A',
    'Admin.PricingCondition.Details.ScaleOrder.B',
    'Admin.CpsPricingConditions.DisplayUnit',
    'Admin.CpsPricingConditions.DeterminationFormula',
    'Admin.CpsPricingConditions.DeterminationFormulaHint',
    'Admin.PricingCondition.QuickSearch',
    'Admin.PricingCondition.Total',
    'Admin.PricingCondition.InfoMessage',
    'Admin.CPSPricingCondition.InfoMessage',
    'Admin.PricingCondition.AddPricingConditionMapping',
    'Admin.PricingCondition.RemovePricingConditonMapping',
    'Admin.PricingCondition.Validation.DuplicateStep',
    'Admin.PricingCondition.Validation.DuplicatePricingConditionField',
    'Admin.PricingCondition.Validation.DuplicateFrequencyMapping',
    'Admin.PricingCondition.Validation.RequiredFieldsEmpty',
    'Admin.PricingCondition.Validation.DefinitionRequiredFieldsEmpty',
    'Admin.PricingCondition.Validation.StepsAreEqualForSameConditionTypes',
    'Admin.PricingCondition.Validation.ConditionTypesAreEqualForSameSteps',
    'Admin.PricingCondition.Validation.DuplicateQuoteHeaders',
    'Admin.PricingCondition.Validation.DuplicateFrequencyMappingForSameQuoteItemStepAndPricingCondition',
    'Admin.PricingCondition.Validation.DuplicateRateValueForQuoteHeaderWithSameStepAndPricingCondition',
    'Admin.CpsPricingConditions.Validation.DuplicateRateValue',
    'Admin.CpsPricingConditions.Validation.DuplicateQuoteItemFields',
    'Admin.CpsPricingConditions.Validation.DuplicateQuoteHeaderFields',
    'Admin.CpsPricingConditions.Validation.InvalidMappings',
    'Admin.CpsPricingConditions.Validation.DifferentOrderItemTypeForTheSamePricingCondition',
    'Admin.CpsPricingConditions.Validation.OrderItemTypeIsRequired',
    'Admin.CpsPricingConditions.Validation.OrderItemType',
    'Admin.CpsPricingConditions.Validation.IvalidScales',

    'Admin.PricingCondition.Details.Field',
    'Admin.PricingCondition.Details.Value',
    'Admin.PricingCondition.Details.Step',
    'Admin.PricingCondition.Details.ConditionType',
    'Admin.PricingCondition.Details.Description',
    'Admin.PricingCondition.Details.ManualEntryFlag',
    'Admin.PricingCondition.Details.ChangeOfRateAllowed',
    'Admin.PricingCondition.Details.ChangeOfValueAllowed',
    'Admin.PricingCondition.Details.IsHeaderCondition',
    'Admin.PricingCondition.Details.IsItemCondition',
    'Admin.PricingCondition.Details.IsGroupCondition',
    'Admin.PricingCondition.Details.ConditionClass',
    'Admin.PricingCondition.Details.CalculationType',
    'Admin.PricingCondition.Details.PlusMinusFlag',
    'Admin.PricingCondition.Details.DataSource',
    'Admin.PricingCondition.DetailsButton',
    'Admin.PricingCondition.OrderItemType.Placeholder',
    'Admin.PricingProcedure.OrderItemTypes.Title',
    'Admin.PricingCondition.OrderItemType',
    'Product.OrderItemType.Sales',
    'Product.OrderItemType.Subscription',
    'Product.OrderItemType.ServiceContract',
    'Admin.PricingCondition.Validation.DuplicateOrderItemTypeForSameQuoteItem',
    'Msg.No',
    'Msg.Yes',

    //Calculation type
    'Admin.PricingCondition.Details.CalculationType.A',
    'Admin.PricingCondition.Details.CalculationType.B',
    'Admin.PricingCondition.Details.CalculationType.C',
    'Admin.PricingCondition.Details.CalculationType.D',
    'Admin.PricingCondition.Details.CalculationType.E',
    'Admin.PricingCondition.Details.CalculationType.F',
    'Admin.PricingCondition.Details.CalculationType.G',
    'Admin.PricingCondition.Details.CalculationType.H',
    'Admin.PricingCondition.Details.CalculationType.I',
    'Admin.PricingCondition.Details.CalculationType.K',
    'Admin.PricingCondition.Details.CalculationType.J',
    'Admin.PricingCondition.Details.CalculationType.L',
    'Admin.PricingCondition.Details.CalculationType.M',
    'Admin.PricingCondition.Details.CalculationType.N',
    'Admin.PricingCondition.Details.CalculationType.O',
    'Admin.PricingCondition.Details.CalculationType.Q',
    'Admin.PricingCondition.Details.CalculationType.R',
    'Admin.PricingCondition.Details.CalculationType.S',
    'Admin.PricingCondition.Details.CalculationType.T',
    'Admin.PricingCondition.Details.CalculationType.U',
    'Admin.PricingCondition.Details.CalculationType.V',
    'Admin.PricingCondition.Details.CalculationType.W',

    //Condtion class
    'Admin.PricingCondition.Details.ConditionClass.A',
    'Admin.PricingCondition.Details.ConditionClass.B',
    'Admin.PricingCondition.Details.ConditionClass.C',
    'Admin.PricingCondition.Details.ConditionClass.D',
    'Admin.PricingCondition.Details.ConditionClass.E',
    'Admin.PricingCondition.Details.ConditionClass.F',
    'Admin.PricingCondition.Details.ConditionClass.G',
    'Admin.PricingCondition.Details.ConditionClass.H',
    'Admin.PricingCondition.Details.ConditionClass.Q',
    'Admin.PricingCondition.Details.ConditionClass.W',

    //Data source
    'Admin.PricingCondition.Details.DataSource.Empty',
    'Admin.PricingCondition.Details.DataSource.A',
    'Admin.PricingCondition.Details.DataSource.B',
    'Admin.PricingCondition.Details.DataSource.C',
    'Admin.PricingCondition.Details.DataSource.D',
    'Admin.PricingCondition.Details.DataSource.E',
    'Admin.PricingCondition.Details.DataSource.F',
    'Admin.PricingCondition.Details.DataSource.G',
    'Admin.PricingCondition.Details.DataSource.H',
    'Admin.PricingCondition.Details.DataSource.I',
    'Admin.PricingCondition.Details.DataSource.J',
    'Admin.PricingCondition.Details.DataSource.K',
    'Admin.PricingCondition.Details.DataSource.L',
    'Admin.PricingCondition.Details.DataSource.M',
    'Admin.PricingCondition.Details.DataSource.N',
    'Admin.PricingCondition.Details.DataSource.O',
    'Admin.PricingCondition.Details.DataSource.Q',
    'Admin.PricingCondition.Details.DataSource.U',
    'Admin.PricingCondition.Details.DataSource.X',
    'Admin.PricingCondition.Details.DataSource.Y',
    'Admin.PricingCondition.Details.DataSource.Z',
    'Admin.PricingCondition.Details.DataSource.EC',
    'Admin.PricingCondition.Details.DataSource.CP',

    //Plus Minus Flag
    'Admin.PricingCondition.Details.PlusMinusFlag.Empty',
    'Admin.PricingCondition.Details.PlusMinusFlag.X',
    'Admin.PricingCondition.Details.PlusMinusFlag.A',

    //Manual Entry Flag
    'Admin.PricingCondition.Details.ManualEntryFlag.Empty',
    'Admin.PricingCondition.Details.ManualEntryFlag.A',
    'Admin.PricingCondition.Details.ManualEntryFlag.B',
    'Admin.PricingCondition.Details.ManualEntryFlag.C',
    'Admin.PricingCondition.Details.ManualEntryFlag.D',

    // Events for pricing procedures
    'Admin.PricingProcedure.PricingProceduresEvents',
    'Admin.PricingProcedure.PricingProceduresEvents.AvailableFieldsOrBusinessPartners',
    'Admin.PricingProcedure.PricingProceduresEvents.SelectedFieldsOrBusinessPartners',
    'Admin.PricingProcedure.PricingProceduresEvents.Title',
    'Admin.PricingProcedure.PricingProceduresEvents.EmptyList',
    'Admin.PricingProcedure.PricingProceduresEvents.InfoMessage.SalesAreaEnabled',
    'Admin.PricingProcedure.PricingProceduresEvents.InfoMessage.SalesAreaDisabled',
    'Admin.PricingProcedure.PricingProceduresEvents.BusinessPartners',
    'Admin.PricingProcedure.PricingProceduresEvents.QuoteCustomFields',
    'Admin.PricingProcedure.PricingProceduresEvents.Search',

    //Markets page
    'Admin.market_defn.MarketCode',
    'Admin.MarketsDataTable.QuickSearch',
    'Admin.market_defn.MarketName',
    'Admin.market_defn.Currency',
    'Admin.market_defn.MarketFactor',
    'Admin.market_defn.DefaultMarket',
    'xmlMarkets',
    'Admin.add_edit_market_defn.IsDefaultMarket',
    'Admin.market_defn.MarketTimeZone',

    //Sales Tax
    'xmlSalesTax',
    'Admin.SalesTax.ExpandCollapseAll',
    'Admin.SalesTax.QuickSearch',
    'Admin.SalesTax.Total',
    'Admin.SalesTax.SelectBusinessPartnerFunction',
    'Admin.SalesTax.CountryState',
    'Admin.SalesTax.ProductType',
    'Admin.SalesTax.TaxRate',
    'Admin.SalesTax.SuccessfullyUpdated',
    'Admin.SalesTax.InvalidTaxRate',
    'Admin.SalesTax.InvalidTaxRateTitle',
    'Admin.SalesTax.SuccessfullyDeleted',
    'xmlAddNewSalesTax',
    'Admin.SalesTax.SuccessfullyAdded',
    'Admin.SalesTax.ChooseCountryState',
    'Admin.SalesTax.BusinessPartnerFunctionSuccessfullyUpdated',
    'Admin.SalesTax.DeleteMsg',
    'Admin.Taxation.TaxationModelAlreadyExists',
    'Admin.SalesTax.BusinessPartnerFunctionInfoIcon',
    'Admin.SalesTax.ProductTypeInfoIcon',

    // Promotions
    'Admin.PromotionsDataTable.Name',
    'Admin.PromotionsDataTable.Description',
    'Admin.PromotionsDataTable.StartDate',
    'Admin.PromotionsDataTable.EndDate',
    'Admin.PromotionsDataTable.Active',
    'xmlPromotions',
    'Admin.Promotions.Permissions',
    'Admin.Promotions.Definition',
    'Admin.Promotions.Details',
    'CategoryModifications.VisibilityOfProductsInfoMessage',
    'Admin.Promotions.Description',
    'Admin.PromotionsDataTable.QuickSearch',
    'Admin.ImportExport.SelectCategories',
    'Admin.CategoryML.Title',
    'ProductList.ChooseCategories',
    'Admin.Promotions.Details.DiscountAppliedOn',
    'Admin.Promotions.Details.QuantityLimit',
    'Admin.Promotions.Details.PromotionType',
    'Admin.Promotions.Details.DiscountType',
    'Admin.Promotions.Details.Value',
    'Admin.Promotions.Details.QtyFrom',
    'Admin.Promotions.Details.QtyTo',
    'Admin.Promotions.Details.NewQtyBreak',
    'Admin.Promotions.Details.CalculationType',
    'Admin.Promotions.Details.NewAmountBreak',
    'Admin.Promotions.Details.QtyBreaks',
    'Admin.Promotions.Details.AmountBreaks',
    'Admin.Promotions.Details.AmountFrom',
    'Admin.Promotions.Details.AmountTo',
    'Admin.Promotions.Details.NewSection',
    'Admin.Promotions.Details.ProductTypes',
    'Admin.Promotions.Details.Products',
    'Admin.Promotions.Details.Categories',
    'Admin.Promotions.AdvancedConditions',
    'Admin.Promotions.SelectValue',
    'Admin.Promotions.AddAdvancedCondition',
    'Admin.Promotions.RuleLogic',
    'Admin.Promotions.RuleLogicInfo',
    'Admin.Promotions.CustomRuleLogicValueInfo',
    'Admin.Promotions.SelectProductTypes',
    'Admin.Promotions.SelectProducts',
    'Admin.PromotionAdvancedConditionObject.Quote',
    'Admin.PromotionAdvancedConditionObject.QuoteItem',
    'Admin.PromotionAdvancedConditionObject.Product',
    'Admin.PromotionAdvancedConditionObject.ProductType',
    'Admin.PromotionAdvancedConditionObject.Category',
    'Admin.PromotionAdvancedConditionSelection.Quantity',
    'Admin.PromotionAdvancedConditionSelection.Amount',
    'Admin.PromotionTranslation.Column.Label',
    'Admin.PromotionTranslation.SelectLanguage',
    'Admin.PromotionTranslation.Column.DefaultLanguage',
    'Admin.PromotionTranslation.PromotionInfo',
    'Admin.PromotionTranslation.PromotionInfo.Name',
    'Admin.PromotionTranslation.PromotionInfo.Description',
    'Admin.PromotionTranslation.Title',
    'Admin.Promotions.AlreadySelectedWarning',
    'Admin.Promotions.QtyFromEqualToPrevQtyTo',
    'Admin.Promotions.AmountFromEqualToPrevAmountTo',
    'Admin.Promotions.QtyFromGreaterThanQtyTo',
    'Admin.Promotions.AmountFromGreaterThanAmountTo',
    'Admin.Promotions.Details.CanNotDeleteMsg',
    'Admin.Promotions.CalculationType.Standard',
    'Admin.Promotions.CalculationType.Cumulative',
    'Admin.Promotions.SelectQuantityAmount',
    'Admin.deflusersetup.PlaceholderForSelectUser',

    // Market Visibility
    'xmlMarketVisibility',
    'Admin.market_visibility.LabelUsers',
    'Admin.market_visibility.LabelUserType',
    'Admin.market_visibility.LabelCompany',
    'Admin.market_visibility.Markets',
    'Admin.market_visibility.Users',
    'Admin.market_visibility.Condition',
    'Admin.market_visibility.QuickFilter',
    'Admin.market_visibility.UserTypePlaceholder',
    'Admin.market_visibility.CompanyPlaceholder',
    'Admin.market_visibility.UserPlaceholder',
    'Admin.market_visibility.UsersAlert',
    'Admin.market_visibility.MarketsAlert',
    'Admin.market_visibility.ConditionAlert',
    'Admin.market_visibility.SelectedMarkets',
    'Admin.market_visibility.AvailableMarkets',
    'Admin.market_visibility.DeleteConfirmation',
    'Admin.Msg.EditTitle',
    'Msg.Delete',
    'Admin.deflusersetup.PlaceholderForSelectUser',

    // Rounding Setup

    'Admin.CartRoundingDefn.NumberofDecimalsRounding',
    'Admin.CartRoundingDefn.NumberofDecimals',
    'Admin.CustomTablesDefineNew.ColumnName',
    'Admin.deleteCarts.JSMSGConfirmDeletion',
    'Admin.CartRoundingDefn.Currency',
    'xmlRoundingSetup',
    'Admin.appParams.RoundingFixOption',
    'Admin.appParams.LabelFixRoundingOpt2',
    'Admin.RoundingSetup.OldQuote.QuickSearch',
    'Admin.RoundingSetup.NewQuote.QuickSearch',
    'Admin.RoundingSetup.DecimalOptions.AwayFromZero',
    'Admin.RoundingSetup.DecimalOptions.toEven',
    'Admin.RoundingSetup.FixOptions.None',
    'Admin.RoundingSetup.FixOptions.FixItems',
    'Admin.RoundingSetup.FixOptions.FixTotals',
    'Admin.CartRoundingDefn.MouseOver',
    'Admin.appParams.RoundingFixOptionInfo',
    'Admin.AppParams.DecimalRoundingInfo',

    // Currencies
    'xmlCurrencies',
    'Admin.Currencies.ColumnName.Currency',
    'Admin.Currencies.ColumnName.ConversionRate',
    'Admin.Currencies.ColumnName.Description',
    'Admin.Currencies.ColumnName.Sign',
    'Admin.Currencies.ColumnName.Default',
    'Admin.Currencies.QuickSearch',
    'Admin.Currencies.CurrencyLabel',
    'Admin.Currencies.CurrencyLabel',
    'Admin.Currencies.CurrencyLabel',
    'Admin.Currencies.ConversionRateLabel',
    'Admin.Currencies.SignLabel',
    'Admin.Currencies.DescriptionLabel',
    'Admin.Currencies.DefaultLabel',
    'Admin.Currencies.DeleteConfirmation',

    // Margin Health
    'xmlMarginHealth',
    'Admin.MarginHealth.Indicators',
    'Admin.MarginHealth.Indicators.Username',
    'Admin.MarginHealth.Indicators.Usertype',
    'Admin.MarginHealth.Indicators.Product',
    'Admin.MarginHealth.Indicators.ProductType',
    'Admin.MarginHealth.Indicators.Condition',
    'Admin.MarginHealth.Indicators.Overall',
    'Admin.MarginHealth.Visibility',
    'Admin.MarginHealth.DesignAndAppearance',
    'Admin.MarginHealth.MarginHealthIndicator',
    'Admin.MarginHealth.MarginHealthIndicator.Users',
    'Admin.MarginHealth.MarginHealthIndicator.UsersAlert',
    'Admin.MarginHealth.MarginHealthIndicator.MarginHealthApplicability',
    'Admin.MarginHealth.MarginHealthIndicator.MarginHealthApplicabilityAlert',
    'Admin.MarginHealth.MarginHealthIndicator.Totals',
    'Admin.MarginHealth.MarginHealthIndicator.SelectedItems',
    'Admin.MarginHealth.MarginHealthIndicator.AllItems',
    'Admin.MarginHealth.MarginHealthIndicator.MarginHealthBoundaries',
    'Admin.MarginHealth.MarginHealthIndicator.MarginHealthBoundariesAlert',
    'Admin.MarginHealth.MarginHealthIndicator.MarginHealthOneTimePrice',
    'Admin.MarginHealth.MarginHealthIndicator.MarginHealthRecurringPrice',
    'Admin.MarginHealth.MarginHealthIndicator.Condition',
    'Admin.MarginHealth.MarginHealthIndicator.ConditionAlert',
    'Admin.MarginHealth.MarginHealthIndicator.UserLabel',
    'Admin.MarginHealth.MarginHealthIndicator.UserPlaceholder',
    'Admin.MarginHealth.MarginHealthIndicator.UserTypeLabel',
    'Admin.MarginHealth.MarginHealthIndicator.UserTypePlaceholder',
    'Admin.MarginHealth.MarginHealthIndicator.ApplicableTo',
    'Admin.MarginHealth.MarginHealthIndicator.Category',
    'Admin.MarginHealth.MarginHealthIndicator.Product',
    'Admin.MarginHealth.MarginHealthIndicator.ProductType',
    'Admin.MarginHealth.MarginHealthIndicator.SelectCategory',
    'Admin.MarginHealth.MarginHealthIndicator.SelectProduct',
    'Admin.MarginHealth.MarginHealthIndicator.SelectProductType',
    'Admin.MarginHealth.Indicators.QuickSearch',
    'Admin.MarginHealth.Indicators.Category',
    'Admin.MarginHealth.DeleteConfirmation',
    'Admin.MarginHealth.Indicators.AppliedTo',
    'Admin.MarginHealth.Indicators.AppliedTo.AllItems',
    'Admin.MarginHealth.Indicators.AppliedTo.SelectedItems',
    'Admin.MarginHealth.Indicators.AppliedTo.Totals',
    'Admin.MarginHealth.MarginHealthVisibility.UserTypes.Customer',
    'Admin.MarginHealth.MarginHealthVisibility.UserTypes.SalesManagement',
    'Admin.MarginHealth.MarginHealthVisibility.UserTypes.Sales',
    'Admin.MarginHealth.MarginHealthVisibility.UserTypes.CustomerQuoteAcceptance',
    'Admin.MarginHealth.MarginHealthVisibility.UserType',
    'Admin.MarginHealth.MarginHealthVisibility.UserTypeAlert',
    'Admin.MarginHealth.DesignAndAppearance.Alert',
    'Admin.MarginHealth.DesignAndAppearance.Colors',
    'Admin.MarginHealth.DesignAndAppearance.Icons',
    'Admin.MarginHealth.DesignAndAppearance.LowMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.MediumMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.HighMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.NotEditableLowMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.NotEditableMediumMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.NotEditableHighMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.IconControlForEmptyValues',
    'Admin.MarginHealth.DesignAndAppearance.MarginIconWhenListPriceIsZero',
    'Admin.MarginHealth.DesignAndAppearance.MarginIconWhenCostIsZero',
    'Admin.MarginHealth.DesignAndAppearance.MarginHealthIcon',
    'Admin.MarginHealth.DesignAndAppearance.LowMarginColor',
    'Admin.MarginHealth.DesignAndAppearance.MediumMarginColor',
    'Admin.MarginHealth.DesignAndAppearance.HighMarginColor',
    'Admin.MarginHealth.DesignAndAppearance.ColorPicker.DefaultColor',
    'Admin.MarginHealth.DesignAndAppearance.ColorPicker.MoreColors',
    'Admin.MarginHealth.DesignAndAppearance.IconsOptions.HighMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.IconsOptions.MediumMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.IconsOptions.LowMarginIcon',
    'Admin.MarginHealth.DesignAndAppearance.IconsOptions.None',
    'MarginHealthVisibilityDefinition.RestoreDefault'
]
